/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DailyNavGPCApproach } from '../models/DailyNavGPCApproach';
import type { DailyNavNoteAttachmentDownload } from '../models/DailyNavNoteAttachmentDownload';
import type { DailyNavNoteAttachmentsCreate } from '../models/DailyNavNoteAttachmentsCreate';
import type { DailyNavNoteAttachmentUploadUrl } from '../models/DailyNavNoteAttachmentUploadUrl';
import type { DailyNavOverrideForm } from '../models/DailyNavOverrideForm';
import type { DailyNavPriceOverrideRequest } from '../models/DailyNavPriceOverrideRequest';
import type { DailyNavPriceOverrideResponse } from '../models/DailyNavPriceOverrideResponse';
import type { DailyNavRecord } from '../models/DailyNavRecord';
import type { DailyNavRecordUpdate } from '../models/DailyNavRecordUpdate';
import type { DailyNavReviewNote } from '../models/DailyNavReviewNote';
import type { DailyNavReviewNoteWrite } from '../models/DailyNavReviewNoteWrite';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DailyNavService {
  /**
   * The GPC approaches (and their non-deleted comps) for one company
   * measurement date, offered up as the source list for the "copy from GPC"
   * Daily NAV comp picker. Scoped solely by the company measurement date --
   * which already identifies the company and firm -- so firm/company ids are
   * not part of the route. Firm access is enforced off the CMD's owning firm.
   * @param companyMeasurementDateId
   * @param page A page number within the paginated result set.
   * @returns DailyNavGPCApproach
   * @throws ApiError
   */
  public static apiDailyNavCompanyMeasurementDatesGpcApproachesList(
    companyMeasurementDateId: string,
    page?: number,
  ): CancelablePromise<Array<DailyNavGPCApproach>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/daily-nav/company-measurement-dates/{company_measurement_date_id}/gpc-approaches/',
      path: {
        'company_measurement_date_id': companyMeasurementDateId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param attachmentId
   * @param page A page number within the paginated result set.
   * @returns DailyNavNoteAttachmentDownload
   * @throws ApiError
   */
  public static apiDailyNavFinalizeAttachmentsDownloadList(
    attachmentId: string,
    page?: number,
  ): CancelablePromise<DailyNavNoteAttachmentDownload> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/daily-nav/finalize/attachments/{attachment_id}/download/',
      path: {
        'attachment_id': attachmentId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param attachmentId
   * @param page A page number within the paginated result set.
   * @returns DailyNavNoteAttachmentDownload
   * @throws ApiError
   */
  public static apiDailyNavNotesAttachmentsDownloadList(
    attachmentId: string,
    page?: number,
  ): CancelablePromise<DailyNavNoteAttachmentDownload> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/daily-nav/notes/attachments/{attachment_id}/download/',
      path: {
        'attachment_id': attachmentId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this daily nav record.
   * @returns DailyNavRecord
   * @throws ApiError
   */
  public static apiDailyNavRead(
    id: number,
  ): CancelablePromise<DailyNavRecord> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/daily-nav/{id}/',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this daily nav record.
   * @param data
   * @returns DailyNavRecordUpdate
   * @throws ApiError
   */
  public static apiDailyNavPartialUpdate(
    id: number,
    data: DailyNavRecordUpdate,
  ): CancelablePromise<DailyNavRecordUpdate> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/daily-nav/{id}/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param page A page number within the paginated result set.
   * @returns DailyNavReviewNote
   * @throws ApiError
   */
  public static apiDailyNavNotesList(
    id: string,
    page?: number,
  ): CancelablePromise<Array<DailyNavReviewNote>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/daily-nav/{id}/notes/',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns DailyNavReviewNote
   * @throws ApiError
   */
  public static apiDailyNavNotesCreate(
    id: string,
    data: DailyNavReviewNoteWrite,
  ): CancelablePromise<DailyNavReviewNote> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/daily-nav/{id}/notes/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param fileType
   * @param page A page number within the paginated result set.
   * @returns DailyNavNoteAttachmentUploadUrl
   * @throws ApiError
   */
  public static apiDailyNavNotesAttachmentsUploadUrlList(
    id: string,
    fileType: string,
    page?: number,
  ): CancelablePromise<DailyNavNoteAttachmentUploadUrl> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/daily-nav/{id}/notes/attachments/upload-url/',
      path: {
        'id': id,
      },
      query: {
        'page': page,
        'file_type': fileType,
      },
    });
  }
  /**
   * @param id
   * @param noteId
   * @param data
   * @returns DailyNavReviewNote
   * @throws ApiError
   */
  public static apiDailyNavNotesPartialUpdate(
    id: string,
    noteId: string,
    data: DailyNavReviewNoteWrite,
  ): CancelablePromise<DailyNavReviewNote> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/daily-nav/{id}/notes/{note_id}/',
      path: {
        'id': id,
        'note_id': noteId,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param noteId
   * @returns void
   * @throws ApiError
   */
  public static apiDailyNavNotesDelete(
    id: string,
    noteId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/daily-nav/{id}/notes/{note_id}/',
      path: {
        'id': id,
        'note_id': noteId,
      },
    });
  }
  /**
   * @param id
   * @param noteId
   * @param data
   * @returns DailyNavReviewNote
   * @throws ApiError
   */
  public static apiDailyNavNotesAttachmentsCreate(
    id: string,
    noteId: string,
    data: DailyNavNoteAttachmentsCreate,
  ): CancelablePromise<DailyNavReviewNote> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/daily-nav/{id}/notes/{note_id}/attachments/',
      path: {
        'id': id,
        'note_id': noteId,
      },
      body: data,
    });
  }
  /**
   * The full SSV to prefill: every security at today's closing price.
   * @param id
   * @param page A page number within the paginated result set.
   * @returns DailyNavOverrideForm
   * @throws ApiError
   */
  public static apiDailyNavOverrideList(
    id: string,
    page?: number,
  ): CancelablePromise<DailyNavOverrideForm> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/daily-nav/{id}/override/',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns DailyNavPriceOverrideResponse
   * @throws ApiError
   */
  public static apiDailyNavOverrideCreate(
    id: string,
    data: DailyNavPriceOverrideRequest,
  ): CancelablePromise<DailyNavPriceOverrideResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/daily-nav/{id}/override/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
}
